import type { ReactNode } from "react";

type LabelValuePairProps = {
  className?: string;
  href?: string;
  label: string;
  value: ReactNode;
};

export function FieldDisplay({
  className = "",
  href,
  label,
  value,
}: LabelValuePairProps) {
  return (
    <div className={`flex flex-col gap-xs ${className}`}>
      <span className="text-sm font-medium text-text-secondary">{label}</span>
      {href ? (
        <a href={href}>
          <div className="text-base font-normal text-utility-blue-700 hover:underline cursor-pointer">
            {value}
          </div>
        </a>
      ) : (
        <div className="text-base font-normal text-text-secondary">{value}</div>
      )}
    </div>
  );
}
